import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import FindProvider from "@/pages/FindProvider";
import ForTaxPros from "@/pages/ForTaxPros";
import ClaimZip from "@/pages/ClaimZip";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import PartnerPortal from "@/pages/PartnerPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import TermsConditions from "@/pages/TermsConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import USMap from "@/pages/USMap";
import ZipLandingPage from "@/pages/ZipLandingPage";
import Advertise from "@/pages/Advertise";
import JobsBoard from "@/pages/JobsBoard";
import PostAJob from "@/pages/PostAJob";
import JobDetail from "@/pages/JobDetail";
import CompetitiveZips from "@/pages/CompetitiveZips";

function ProtectedRoute({ children, requiredRole }) {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-[#003366] font-semibold text-lg animate-pulse">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/find-provider" element={<FindProvider />} />
            <Route path="/for-tax-pros" element={<ForTaxPros />} />
            <Route path="/claim" element={<ClaimZip />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/find/:industrySlug/:zip" element={<ZipLandingPage />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/portal" element={
              <ProtectedRoute>
                <PartnerPortal />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/map" element={<USMap />} />
            <Route path="/jobs" element={<JobsBoard />} />
            <Route path="/jobs/:jobId" element={<JobDetail />} />
            <Route path="/post-a-job" element={<PostAJob />} />
            <Route path="/competitive-zips" element={<CompetitiveZips />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
